import { Box, Table, Tbody, Td, Text, Th, Thead, Tr, Flex } from '@chakra-ui/react';
import { flexRender, getCoreRowModel, getSortedRowModel, useReactTable, createColumnHelper } from '@tanstack/react-table';
import { useMemo, useState } from 'react';
import { IconButton } from '@chakra-ui/react';
import isEmpty from 'lodash/isEmpty';
import { ViewIcon } from '@chakra-ui/icons';
import { formatDate, formatNumber } from 'utils/helpers';
import { GAME_TYPE_MISSION, MISSION_TYPE, MISSION_TYPE_SUB, ModalType } from 'constants/common';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { BiCommentDetail } from 'react-icons/bi';
import moment from 'moment';

const MissionTable = ({ tableData, handleUpdateCategory, refetch, handleShowMemberDetail }) => {
  const [sorting, setSorting] = useState([]);
  const columnHelper = createColumnHelper();
  const history = useHistory();

  // const handleRowClick = (ticket, type) => {
  //   handleUpdateCategory(ticket, type);
  // };

  const handleViewClick = (idMember, ModalType) => {
    handleShowMemberDetail(idMember, ModalType);
  };

  const columns = useMemo(
    () => [
      columnHelper.accessor('member.username', {
        header: 'Tên tài khoản',
        cell: info => info.getValue(),
      }),
      columnHelper.accessor('member.level', {
        header: 'Cấp độ (Nhà cái)',
        cell: info => info.getValue() || '--',
      }),
      columnHelper.accessor('member.kkLevel', {
        header: 'Cấp độ HTTĐ',
        cell: info => info.getValue() || '--',
      }),
      columnHelper.accessor('currentMemberCoin', {
        header: 'Xu trước nhận',
        cell: info => info.getValue(),
      }),
      columnHelper.accessor('coin', {
        header: 'Xu thực nhận',
        cell: info => info.getValue(),
      }),
      columnHelper.accessor('memberCoinAfterCollect', {
        header: 'Xu sau nhận',
        cell: info => info.getValue() || info.row?.original.currentMemberCoin + info.row?.original?.coin,
      }),
      columnHelper.accessor('currentMemberAmount', {
        header: 'Tổng nạp Hội viên',
        cell: info =>
          info.row.original.type === MISSION_TYPE.RECHARGE_IN_DAY || info.row.original.type === MISSION_TYPE.RECHARGE_IN_WEEK
            ? formatNumber(info.getValue())
            : '-',
      }),
      columnHelper.accessor('currentMemberAmount', {
        header: 'Tổng DTC Hội viên',
        cell: info =>
          info.row.original.type === MISSION_TYPE.BET_IN_DAY || info.row.original.type === MISSION_TYPE.BET_IN_WEEK
            ? formatNumber(info.getValue())
            : '-',
      }),
      columnHelper.accessor('mission.title', {
        header: 'Tên nhiệm vụ',
        cell: info => info.getValue(),
      }),
      columnHelper.accessor('mission.type', {
        header: 'Loại nhiệm vụ',
        cell: info => MISSION_TYPE_SUB[info.getValue()],
      }),
      columnHelper.accessor('mission.level', {
        header: 'Cấp bậc yêu cầu',
        cell: info => info.getValue() || '--',
      }),
      columnHelper.accessor('mission.gameTypes', {
        header: 'Loại game',
        cell: info => (info.getValue()?.length ? info.getValue()?.map(i => <Text key={i}>{GAME_TYPE_MISSION[i]}</Text>) : '--'),
      }),
      columnHelper.accessor('mission.coinCollect', {
        header: 'Xu thưởng từ nhiệm vụ',
        cell: info => info.getValue(),
      }),
      columnHelper.accessor('mission.totalAmountToCollect', {
        header: 'Tổng nạp/ Tổng DTC yêu cầu',
        cell: info => info.getValue(),
      }),
      columnHelper.accessor('date', {
        header: 'Nhiệm vụ ngày',
        cell: info => formatDate(info.getValue(), 'DD-MM-YYYY'),
      }),
      columnHelper.accessor('createdAt', {
        header: 'Ngày nhận',
        cell: info => formatDate(info.getValue(), 'DD-MM-YYYY HH:mm'),
      }),
    ],
    [tableData]
  );

  const table = useReactTable({
    data: tableData || [],
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  return (
    <Table>
      <Thead>
        {table.getHeaderGroups().map(headerGroup => (
          <Tr key={headerGroup.id}>
            {headerGroup.headers.map(header => (
              <Th key={header.id} w="120px">
                {header.isPlaceholder ? null : (
                  <Box
                    isTruncated
                    cursor={header.column.getCanSort() ? 'pointer' : 'default'}
                    onClick={header.column.getToggleSortingHandler()}
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                    {{
                      asc: ' 🔼',
                      desc: ' 🔽',
                    }[header.column.getIsSorted()] ?? null}
                  </Box>
                )}
              </Th>
            ))}
          </Tr>
        ))}
      </Thead>
      <Tbody>
        {isEmpty(table.getRowModel().rows) ? (
          <Tr>
            <Td textAlign="center" colSpan={15}>
              Không có dữ liệu
            </Td>
          </Tr>
        ) : (
          table.getRowModel().rows.map(row => (
            <Tr key={row.id}>
              {row.getVisibleCells().map(cell => (
                <Td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>
              ))}
            </Tr>
          ))
        )}
      </Tbody>
    </Table>
  );
};

export default MissionTable;
